import React, { useEffect } from 'react';

const ResearchAnalystPage = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css";
    link.rel = "stylesheet";
    link.id = "tailwind-mutualfund"; // Add ID so you can remove it later if needed
    document.head.appendChild(link);

    return () => {
      // Optional: Clean up when component unmounts
      document.getElementById("tailwind-mutualfund")?.remove();
    };
  }, []);
  return (
    <>
      <section className="bg-blue-50 py-16 text-center">
        <h1 className="text-4xl font-bold text-blue-900 mb-4">Certified Research Analyst Services by GPS Finvest</h1>
        <p className="text-lg text-gray-700 mb-6">Make smarter investment decisions with expert research, technical analysis, and actionable insights.</p>
        <div ><a className="btn btn-primary" href="https://gpsfinvest.investwell.app/app/#/login">Request Research Access</a></div>
      </section>

      <section className="py-16 bg-white">
        <div className='col-md-12' style={{ display: 'flex', justifyContent: 'center' }}>
          <img src='/images/Research_Analyst.jpg' style={{ height: '300px' }} />
        </div>
        <div className="max-w-4xl mx-auto px-4 text-center mt-3">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">What Does a Research Analyst Do?</h2>
          <p className="text-lg text-gray-600">A SEBI-registered Research Analyst provides data-backed recommendations on stocks, mutual funds, and sectors. At GPS Finvest, our research team offers fundamental and technical reports, market outlooks, and tailored investment strategies to help you maximize returns with confidence.</p>
        </div>
      </section>

      <section className="py-16 bg-green-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10 text-gray-800">Why Choose GPS Finvest Research Services?</h2>
          <div className="grid md:grid-cols-4 gap-6 text-left">
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Certified_Analysts.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Certified Analysts</h3>
              <p>Access research from SEBI-registered professionals with proven market experience.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Actionable_Insights.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Actionable Insights</h3>
              <p>Get daily/weekly calls with stop-loss, targets, and conviction levels.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Custom_Reports.webp" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Custom Reports</h3>
              <p>Request research tailored to your portfolio or watchlist.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Coverage.jpg" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">360° Market Coverage</h3>
              <p>Equity, commodities, sectors, macroeconomics — we cover all major segments.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10 text-gray-800">How to Access Research Analyst Services</h2>
          <div className="grid md:grid-cols-4 gap-6 text-left">
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">1. Contact Us</h3>
              <p>Reach out to our team or fill out the request form for onboarding.</p>
            </div>
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">2. Subscription Setup</h3>
              <p>Choose your plan — daily, weekly, or customized research support.</p>
            </div>
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">3. Receive Reports</h3>
              <p>Get updates via email, WhatsApp, or login dashboard based on your preference.</p>
            </div>
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">4. Track & Discuss</h3>
              <p>Track your strategy and book follow-up calls for clarification and guidance.</p>
            </div>
          </div>
          <div className="mt-8">
            <div ><a className="btn btn-primary" href="#"><i className="fa-solid fa-phone"></i> Schedule Analyst Call</a></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResearchAnalystPage;
